/** Most agents one message can go to at once (matches the chat grid). */
export const MAX_BROADCAST = 6;

export interface BroadcastPane {
  key: string;
  agentId?: string | null;
}

export interface BroadcastTarget {
  agentId: string;
  /** Open conversation with this agent to send into; absent = start a new conversation. */
  conversationId?: string;
}

/**
 * Decide where a message to several agents goes: into the conversation the user already has open with that
 * agent (the focused one if there are several), otherwise a new conversation. Deterministic, no LLM.
 */
export function planBroadcast(
  agentIds: readonly string[],
  panes: readonly BroadcastPane[],
  focused: string | null,
): BroadcastTarget[] {
  const chats = panes.filter((p) => p.key.startsWith('chat:') && p.agentId);
  return [...new Set(agentIds)].slice(0, MAX_BROADCAST).map((agentId) => {
    const open = chats.filter((p) => p.agentId === agentId);
    const pick = open.find((p) => p.key === focused) ?? open[open.length - 1];
    return pick ? { agentId, conversationId: pick.key.slice('chat:'.length) } : { agentId };
  });
}
